import { createRouter, createWebHistory } from 'vue-router'
import { DENTAL_HIRING_ROUTES, DENTAL_RATER_ROUTES } from './dentalRoutes'
import { activeMock, hideHeader } from './guards'
import { HEALTH_HIRING_ROUTES, HEALTH_RATER_ROUTES } from './healthRoutes'
import { HOME_RATER_ROUTES } from './homeRoutes'
import { LIFE_HIRING_ROUTES, LIFE_RATER_ROUTES } from './lifeRoutes'
import { PETS_HIRING_ROUTES, PETS_RATER_ROUTES } from './petsRoutes'

import { COMMON_HIRING_ROUTES, COMMON_RATER_ROUTES } from './commonRoutes'
import { FOREIGN_HEALTH_HIRING_ROUTES, FOREIGN_HEALTH_RATER_ROUTES } from './foreignHealthRoutes'
import { TRAVEL_HIRING_ROUTES, TRAVEL_RATER_ROUTES } from './travelRoutes'

const ROUTER_BASE_PATH = import.meta.env.BASE_URL + import.meta.env.VITE_SERVER_BASE_FOLDER

export function createDefaultRouter() {
  const router = createRouter({
    history: createWebHistory(ROUTER_BASE_PATH),
    routes: [
      {
        path: '/',
        name: 'rater',
        component: () => import('../modules/common/common/views/IndexView.vue'),
        meta: {
          title: 'Calcula el Precio de los Seguros ASISA | ASISA',
          description:
            'Encuentra el precio de todos los seguros ASISA con nuestro tarificador. Compara todas las tarifas de ASISA de forma rápida y fácil.',
          phone: '917 619 300'
        },
        children: [
          ...COMMON_RATER_ROUTES,
          ...HEALTH_RATER_ROUTES,
          ...DENTAL_RATER_ROUTES,
          ...LIFE_RATER_ROUTES,
          ...PETS_RATER_ROUTES,
          ...TRAVEL_RATER_ROUTES,
          ...FOREIGN_HEALTH_RATER_ROUTES,
          ...HOME_RATER_ROUTES
          // add the following routes
        ]
      },
      {
        path: '/contratacion',
        name: 'hiring',
        component: () => import('../modules/common/common/views/IndexView.vue'),
        meta: {
          phone: '917 619 301'
        },
        children: [
          ...COMMON_HIRING_ROUTES,
          ...HEALTH_HIRING_ROUTES,
          ...DENTAL_HIRING_ROUTES,
          ...LIFE_HIRING_ROUTES,
          ...PETS_HIRING_ROUTES,
          ...TRAVEL_HIRING_ROUTES,
          ...FOREIGN_HEALTH_HIRING_ROUTES,
          // add the following routes

          {
            path: '',
            redirect: '/'
          }
        ]
      },
      {
        path: '/documento/:hash',
        name: 'document',
        component: () => import('../modules/common/hiring/views/DocumentImageParent.vue'),
        meta: {
          title: 'Seguros Médicos ASISA',
          hideFooter: true
        }
      },
      {
        path: '/:pathMatch(.*)*',
        redirect: '/'
      }
    ]
  })

  router.beforeEach(async (to: any /*from: any*/) => {
    if (to.path === '/components' && window.location.hostname !== '127.0.0.1') {
      // redirect the user to the login page
      return '/salud'
    }
    if (to.query && to.query.showHeader === 'false') {
      hideHeader()
    }
    //TODO: COMMENTS BY ENVIRONMENT
    if (to.query && to.query.mock === 'true') {
      activeMock()
    }
  })

  return router
}

export default createDefaultRouter()
